import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/inventory/fd/product-group",
        component: List,
        name: "fd.inventory.product.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/inventory/fd/product-group/create",
        component: Create,
        name: "fd.inventory.product.group.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/inventory/fd/product-group/:id/edit",
        component: Edit,
        name: "fd.inventory.product.group.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
